import { render, staticRenderFns } from "./simple-therapy-form.vue?vue&type=template&id=550b779a&scoped=true&lang=pug&"
import script from "./simple-therapy-form.vue?vue&type=script&lang=ts&"
export * from "./simple-therapy-form.vue?vue&type=script&lang=ts&"
import style0 from "./simple-therapy-form.vue?vue&type=style&index=0&id=550b779a&scoped=true&lang=css&"
import style1 from "./simple-therapy-form.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b779a",
  null
  
)

export default component.exports